import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import CustomInput from "../CustomInput";
import { Button } from "../ui/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showSuccessToast } from "src/lib/utils";
import { verifyBVN } from "src/api/settings";
import { usePortalContext } from "src/context/PortalContext";
import { useAuth } from "src/providers/AuthProvider";

const UpgradeToTier2 = () => {
	const { user } = useAuth();
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		businessUuid: user?.business_uuid,
		bvn: "",
	};
	const validationSchema = Yup.object().shape({
		bvn: Yup.string().required("BVN is required").length(11, "A valid bvn is 11 characters long"),
	});

	const { mutate, isLoading } = useMutation(verifyBVN, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["account-tiers", "business"]);
			queryClient.invalidateQueries(["user"]);
			closePortal();
		},
	});

	return (
		<div>
			<p className="tw-text-gray tw-font-medium tw-text-sm tw-mb-6">
				Upon verification, your account will be upgraded to tier 2, enjoying a transaction limit of N10,000.00 and a maximum balance of
				N100,000,000
			</p>
			<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
				{({ values, handleChange, handleSubmit }) => (
					<form onSubmit={handleSubmit} className="tw-grid">
						<CustomInput label="Verify BVN" name="bvn" type="text" placeholder="1001393913012" value={values.bvn} onChange={handleChange}>
							<p className="tw-mt-1 tw-block tw-text-sm tw-font-medium tw-text-[#A7A7A7]">Dial *384*1# to get your BVN</p>
						</CustomInput>
						<Button disabled={isLoading} className="mt-2">
							Verify
						</Button>
					</form>
				)}
			</Formik>
		</div>
	);
};

export default UpgradeToTier2;
